
export type SortByParam2Parameter = typeof SortByParam2Parameter[keyof typeof SortByParam2Parameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortByParam2Parameter = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  views: 'views',
  likes: 'likes',
  comments: 'comments',
} as const;
